/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useIsMobileWeb} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {IllustrationVerify} from './illustrations'
import {IllustrationArea, PageShell} from './primitives'

export function StepVerifyHuman({
  onSkip,
  onNext,
}: {
  onSkip?: () => void
  onNext: () => void
}) {
  const isMobileWeb = useIsMobileWeb()

  return (
    <PageShell>
      <IllustrationArea>
        <IllustrationVerify />
      </IllustrationArea>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>Verify you&apos;re human</Heading>
        <BodyText>You must verify your account to post or interact.</BodyText>
      </div>

      {isMobileWeb ? (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}>
          <Button
            label="Verify with ID"
            color="primary"
            size="large"
            testID="verifyNowBtn"
            onPress={onNext}
            style={{alignSelf: 'stretch'}}>
            <ButtonText>Verify with ID</ButtonText>
          </Button>
          {onSkip && (
            <Button
              label="Remind me later"
              color="secondary"
              size="large"
              testID="remindLaterBtn"
              onPress={onSkip}
              style={{alignSelf: 'stretch'}}>
              <ButtonText>Remind me later</ButtonText>
            </Button>
          )}
        </div>
      ) : (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            justifyContent: 'center',
            gap: 10,
          }}>
          {onSkip && (
            <Button
              label="Remind me later"
              color="secondary"
              size="large"
              testID="remindLaterBtn"
              onPress={onSkip}>
              <ButtonText>Remind me later</ButtonText>
            </Button>
          )}
          <Button
            label="Verify with ID"
            color="primary"
            size="large"
            testID="verifyNowBtn"
            onPress={onNext}>
            <ButtonText>Verify with ID</ButtonText>
          </Button>
        </div>
      )}
    </PageShell>
  )
}
